export const Mails =
    [
        {
            from: 'martine.kolpberg@wanadoo.fr',
            object: 'absences',
            date: '16/05/2005 10:22',
            content: `Bonjour Lana,

            Nous nous inquiétons avec le corps enseignant concernant vos absences répétées lors de cette dernière semaine.
            
            Donnez-nous de vos nouvelles
            
            Cdt
            Mme Kolpberg`
        },
        {
            from: 'justine.portalier@yahoo.fr',
            object: 'Devoir de Chimie ',
            date: '02/05/2005 19:03',
            content: `Coucou Lana,
            
            Tiens, comme promis le devoir de physique ! 

            Passes une bonne journée !

            Justine`
        },
        {
            from: 'superpizza.miam@yahoo.fr',
            object: 'Info programme de fidélité',
            date: '13/04/2005 17:32',
            content: `Chère cliente, cher client,

            Nous souhaitions vous informer que nous rencontrons actuellement des problèmes techniques sur notre programme de fidélité.
            
            Les points acquis lors de vos commandes restent en effet en attente et ne peuvent pas être crédités sous 48h.
            
            Nous sommes sincèrement désolés pour la gêne occasionnée et tenons à vous rassurer, l’ensemble de notre équipe technique est mobilisé pour corriger ce problème au plus vite afin que vos points soient crédités.
            
            Nous vous tiendrons au courant lorsque la validation de vos points sera rétablie.
            
            Au plaisir,

            Votre Service client de qualité.`
        },
        {
            from: 'info@ebay.fr',
            object: 'Recommendations d’articles',
            date: '11/04/2005 18:11',
            content: `Bonjour Lana Lariviere, 

            D’après votre activité récente sur notre site, nous avons de nombreux articles à vous proposer.
            
            A très bientot.`
        },
        {
            from: 'martine.kolpberg@wanadoo.fr',
            object: 'DM de mathématiques',
            date: '16/01/2005 19:32',
            content: `Bonjour Lana,

            Je n’ai pas encore reçu ton DM de mathématiques,

            J’espère le recevoir sous peu, dans le cas contraire je serai forcée de te pénaliser pour le retard.


            Cdt
            Mme Kolpberg`
        },
        {
            from: 'video-futur@hotmail.fr',
            object: 'Votre abonnement',
            date: '02/12/2004 16:21',
            content: `Bonjour Lana,
            
            Nous vous remercions pour votre abonnement à vie aux services proposés par Vidéo Futur.
            
            Nous ne vous décevrons pas quant à la qualité de nos services, tant que nos boutiques resterons ouvertes vous en bénéficierez sans frais supplémentaires.

            Merci de votre confiance.

            Cordialement.
            `
        },
        {
            from: 'fernand.lariviere@wanadoo.fr',
            object: 're: factures',
            date: '11/08/2004 12:43',
            content: `
            Hello ma chérie,
            
            Bien recu. Merci pour l’info. 
            
            Je m’en occuperais quand je m’y rendrais. 
            
            Bises

            ---

            De : lana.lariviere@hotmail.fr 
            Objet : factures

            Salut papa, on a reçu des factures dans la maison.

            Je t’envoie une photo pour que tu vois ce qu’il y a.

            Bisous.
            `,
            photo: true
        },
        {
            from: 'admin@napster.com',
            object: 'Napster - Suggestions',
            date: '09/08/2004 09:33',
            content: `Bonjour, 

            Nous avons des musiques à vous suggérer,

            Au plaisir de vous revoir bientôt sur notre plateforme`
        },
        {
            from: 'fernand.lariviere@wanadoo.fr',
            object: 'Voyage famille',
            date: '20/07/2004 08:58',
            content: `Coucou, 
            
            j’espère que tu vas bien, je t’envoie un mail juste pour te prévenir qu’on part en vacances avec ta mère dans 2 jours.

            Amuses-toi bien, tu auras la maison de libre ;-)


            Bises`
        },
        {
            from: 'superpizza.miam@yahoo.fr',
            object: 'Votre commande',
            date: '18/07/2004 21:47',
            content: `Bonjour Lana,

            Nous espérons que vous avez passé un bon moment grâce à Super pizza. 
            
            Votre avis compte.
            `
        },
        {
            from: 'info@ebay.fr',
            object: 'Confirmation de commande',
            date: '17/07/2004 11:47',
            content: `Confirmation de votre commande.
            
            Nous vous confirmons que la commande effectuée sur notre site a bien été prise en compte.
            `
        },
        {
            from: 'rhum.coco@yahoo.fr',
            object: 'Service de dégustation de rhum à domicile',
            date: '16/07/2004 15:40',
            content: `Bonjour consommateurs,
            
            Nous proposons une réduction de 75 % sur nos offres de dégustations de rhum à domicile !
            
            Saisissez votre chance et venez commander une de nos nombreuses offres sur notre site internet : Dégustation-rhum.com
            
            Vous pouvez contacter notre hotline si vous avez soif. 
            `
        },
        {
            from: 'newsletters@change.org',
            object: 'Confirmation adresse e-mail',
            date: '23/06/2004 17:49',
            content: `Bonjour,

            Veuillez confirmer votre adresse électronique en cliquant sur le lien ci-dessous.

            http://www.change.org/hdshjsdnjc/02514/usjsadjjz

            Merci d'avance.
            `
        },
        {
            from: 'alfredodu78@hotmail.fr',
            object: 'Code César',
            date: '07/05/2003 21:12',
            content: `Yooo, regarde pour le code cesar dont je t'avais parlé:


            En cryptographie, le chiffrement par décalage, aussi connu comme le chiffre de César ou le code de César, est une méthode de chiffrement très simple utilisée par Jules César dans ses correspondances secrètes.

            Le texte chiffré s'obtient en remplaçant chaque lettre du texte clair original par une lettre à distance fixe, toujours du même côté, dans l'ordre de l'alphabet. Pour les dernières lettres (dans le cas d'un décalage à droite), on reprend au début. Par exemple avec un décalage de 3 vers la droite, A est remplacé par D, B devient E, et ainsi jusqu'à W qui devient Z, puis X devient A etc.
            

            C'est pas mal non ? ;)

            A+++
            `
        },
        {
            from: 'aliicee02@yahoo.fr',
            object: 'Lanaaaaaa',
            date: '15/06/2002 14:07',
            content: `Saaalut alors tu me dis pas bonjour ce matin???
            
            On reglera ca ahahahaha`
        }
    ]